import { render, staticRenderFns } from "./ChooseBoxModal.vue?vue&type=template&id=674dd488&scoped=true&"
import script from "./ChooseBoxModal.vue?vue&type=script&lang=js&"
export * from "./ChooseBoxModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseBoxModal.vue?vue&type=style&index=0&id=674dd488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674dd488",
  null
  
)

export default component.exports